module.exports = __webpack_public_path__ + "img/4.bc3633f1.jpg";